export const EnvSelector = ({ production, development }) => {
  const isDev = !process.env.NODE_ENV || process.env.NODE_ENV === "development";
  return isDev ? development : production;
};

export const BASE_CAPTCHA_IMAGE_URL = EnvSelector({
  production: "https://www.defadoc.ir",
  development: "http://188.253.3.131:8000",
});
export const BASE_API_URL = EnvSelector({
  production: "https://www.defadoc.ir/api",
  development: "http://188.253.3.131:8000/api",
});
export const LIST_PAGE_SIZE = 10;
export const RESEND_TOP_INTERVAL_IN_SECONDS = 90;
